import React     from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';

const SetStatus = ({ statusCode, children }) => {
	return (
		<Route
			render={({ staticContext }) => {
				if (staticContext)
					staticContext.statusCode = statusCode;
				return children;
			}}
		/>
	);
};

export default SetStatus;

SetStatus.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	]).isRequired,
	statusCode: PropTypes.number.isRequired
};
